import axios from 'axios';
import { getToken } from '../helpers/hasToken';

const API_URL = process.env.REACT_APP_API_SERVICE;

export const getIsJobAlreadyApplied = async (jobId, schemaName) => {
    try {
        const res = await axios.get(`${API_URL}/users/status/${jobId}/${schemaName}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            });
        return res;
    } catch (error) {
        return error;
    }
};

// Save a job for a candidate
export const saveJob = async (jobId) => {
    try {
        const token = getToken();
        const res = await axios.post(`${API_URL}/savedjobs`, { jobId },
            {
                headers: {
                    "Content-Type": "application/json",
                    ...(token && { "Authorization": `Bearer ${token}` })
                },
            });
        return res;
    } catch (error) {
        return error.response || error;
    }
};

// Get saved jobs for a candidate
export const getSavedJobs = async () => {
    try {
        const token = getToken();
        const res = await axios.get(`${API_URL}/savedjobs`,
            {
                headers: {
                    "Content-Type": "application/json",
                    ...(token && { "Authorization": `Bearer ${token}` })
                },
            });
        return res;
    } catch (error) {
        return error.response || error;
    }
};

// Remove a saved job
export const removeSavedJob = async (jobId) => {
    try {
        const token = getToken();
        const res = await axios.delete(`${API_URL}/savedjobs/${jobId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    ...(token && { "Authorization": `Bearer ${token}` })
                },
            });
        return res;
    } catch (error) {
        return error.response || error;
    }
};
